import { render, staticRenderFns } from "./StandAndFun.vue?vue&type=template&id=0fb5c13a&scoped=true&"
import script from "./StandAndFun.vue?vue&type=script&lang=js&"
export * from "./StandAndFun.vue?vue&type=script&lang=js&"
import style0 from "./StandAndFun.vue?vue&type=style&index=0&id=0fb5c13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5c13a",
  null
  
)

export default component.exports